import React from "react";

import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { HomeWrapper } from "../../components";

export default function HomePage() {
  return (
    <PaginationProvider>
      <ModalProvider>
        <HomeWrapper />
      </ModalProvider>
    </PaginationProvider>
  );
}
